import React from 'react';

export function BackToTop() {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            onClick={handleClick}
            className="back-to-top d-flex align-items-center justify-content-center"
            aria-label="Back to top"
            type="button"
        >
            <i className="bi bi-arrow-up-short" />
        </button>
    );
}
